import React from 'react'
import { ThemeProvider } from '@mui/material'

import { internalLightTheme } from '~createInternalTheme'
import { type AIInteractionTranscript, type EnrichedOrganizationAISettings } from '~types'

import ShareLogModalV2Content from './ShareLogModalContent'

interface ShareLogModalProps {
  isOpen: boolean
  onClose: () => void
  aiInteractionId: string
  transcript: AIInteractionTranscript | null
  orgAiSettings: EnrichedOrganizationAISettings | null
}

const ShareLogModal: React.FC<ShareLogModalProps> = (props) => (
  <ThemeProvider theme={internalLightTheme}>
    <ShareLogModalV2Content {...props} />
  </ThemeProvider>
)

export default ShareLogModal
